/**
 * Shared locale mapping utility for client and server-side use
 * Maps locale codes to their technical format for third-party services
 */

export interface LocaleMapping {
  [key: string]: string;
}

/**
 * Returns the locale mapping object for CookieInformation culture codes
 * @returns Record of locale codes to CookieInformation culture format
 */
export function getLocaleMapping(): LocaleMapping {
  return {
    'de-at': 'DE',
    'nl-be': 'NL',
    'fr-be': 'FR',
    da: 'DA',
    fr: 'FR',
    de: 'DE',
    it: 'IT',
    no: 'NB',
    pl: 'PL',
    pt: 'PT',
    es: 'ES',
    sv: 'SV',
    'de-ch': 'DE',
    'fr-ch': 'FR',
    'it-ch': 'IT',
    nl: 'NL',
    'en-gb': 'EN',
    'en-us': 'EN',
    'en-ca': 'EN',
    'fr-ca': 'FR',
    'en-ie': 'EN',
    'en-lu': 'EN',
    'fr-lu': 'FR',
    'en-au': 'EN',
    ja: 'JA',
    'en-nz': 'EN',
  };
}

/**
 * Maps a locale string to its CookieInformation culture format
 * @param locale - The locale string to map (e.g., 'en-gb', 'es-es')
 * @param fallback - Fallback value if locale is not found (default: 'EN')
 * @returns The mapped CookieInformation culture code or fallback value
 */
export function mapLocaleToTech(locale: string, fallback: string = 'EN'): string {
  const mapping = getLocaleMapping();
  return mapping[locale.toLowerCase()] || fallback;
}

/**
 * Legacy function name for backward compatibility
 * @deprecated Use mapLocaleToTech instead
 */
export function localizationToTech(): LocaleMapping {
  return getLocaleMapping();
}
